import { useEffect, useState } from 'react';
import { FlexContainer, Text, ProgressBar } from '@taxdown/piccolo-web';
import * as Styled from '../../styles';

const ProgressDisplay = ({ totalAmount }: { totalAmount: number }): JSX.Element => {
  const [progress, setProgress] = useState(10);
  const [currentAmount, setCurrentAmount] = useState(10);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setProgress(prev => {
        const newProgress = Math.min(prev + 10, 99);
        setCurrentAmount(() => {
          if (newProgress === 99) {
            return totalAmount;
          }
          return Math.round(totalAmount * (newProgress / 99));
        });
        if (newProgress === 99) clearInterval(intervalId);
        return newProgress;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [totalAmount]);

  const price = `+${currentAmount.toFixed(2)}`;

  return (
    <>
      <Text type="headline" size="M_L_S" color="fresh">
        {price}
      </Text>
      <FlexContainer fullWidth align="center" justify="center" gap="dimension_08">
        <Styled.ProgressBarContent>
          <ProgressBar baseColor="" filled={progress} filledColor="" />
        </Styled.ProgressBarContent>
        <Text type="paragraphs" size="M_L_S" color="success_strong">
          {`${progress}%`}
        </Text>
      </FlexContainer>
    </>
  );
};

export default ProgressDisplay;
